import { createAction, props } from '@ngrx/store';

import { Session } from '@lockton-apps/shared/interfaces';

import { AuthApiActionTypes } from './actions.model';

export const loginSuccess = createAction(
  AuthApiActionTypes.LoginSuccess,
  props<{ session: Session }>()
);

export const loginFailure = createAction(
  AuthApiActionTypes.LoginFailure,
  props<{ message: any; code?: number }>()
);

export const signUpSuccess = createAction(
  AuthApiActionTypes.SignUpSuccess,
  props<{ session: Session }>()
);

export const signUpFailure = createAction(
  AuthApiActionTypes.SignUpFailure,
  props<{ message: any }>()
);

export const forgotPasswordSuccess = createAction(
  AuthApiActionTypes.ForgotPasswordSuccess
);

export const forgotPasswordFailure = createAction(
  AuthApiActionTypes.ForgotPasswordFailure,
  props<{ message: string }>()
);

export const resend2faCodeSuccess = createAction(
  AuthApiActionTypes.Resend2faCodeSuccess,
  props<{ message: string }>()
);

export const resend2faCodeFailure = createAction(
  AuthApiActionTypes.Resend2faCodeFailure,
  props<{ message: string }>()
);

export const twoFactorAuthFailure = createAction(
  AuthApiActionTypes.TwoFactorAuthFailure,
  props<{ message: string }>()
);

export const resetPasswordSuccess = createAction(
  AuthApiActionTypes.ResetPasswordSuccess
);

export const resetPasswordFailure = createAction(
  AuthApiActionTypes.ResetPasswordFailure,
  props<{ message: string }>()
);

export const setPasswordSuccess = createAction(
  AuthApiActionTypes.SetPasswordSuccess
);

export const setPasswordFailure = createAction(
  AuthApiActionTypes.SetPasswordFailure,
  props<{ message: string }>()
);

export const changePasswordSuccess = createAction(
  AuthApiActionTypes.ChangePasswordSuccess
);

export const changePasswordFailure = createAction(
  AuthApiActionTypes.ChangePasswordFailure,
  props<{ message: string }>()
);

export const contactAuthenticated = createAction(
  AuthApiActionTypes.ContactAuthenticated
);
